import { render } from "./CheckBox.vue?vue&type=template&id=ffa40922&scoped=true&ts=true"
import script from "./CheckBox.vue?vue&type=script&lang=ts"
export * from "./CheckBox.vue?vue&type=script&lang=ts"

import "./CheckBox.vue?vue&type=style&index=0&id=ffa40922&scoped=true&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffa40922"]])

export default __exports__